<template>
<div class="page_toutiao page_toutiaoDetail">
    <!-- 顶部匠人信息 -->
    <div class="list">
        <div class="item">
            <div class="item_t">
                <div class="item_t_l">
                    <van-image fit="cover" :src="info.userthumb ? ($publicData.withHttpStart(info.userthumb) ? info.userthumb : imageUrl+info.userthumb) : $publicData.headLineTouxiang" class="tu" :show-error="true" :error-icon="$publicData.headLineTouxiang" :show-loading="false" />
                    <!-- <img :src="info.userthumb ? info.userthumb : $publicData.headLineTouxiang" alt="" class="tu"> -->
                    <div class="text">
                        <div class="text_t">
                            <div class="title slh_s">{{ info.username }}</div>
                        </div>
                        <div class="time">{{ info.push_at }}</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- 头条信息 -->
    <div class="info">
        <div class="title" v-if="info.type != 0">{{ info.title }}</div>
        <div class="jieshao" v-if="info.type == 2" v-html="info.content"></div>
        <div class="jieshao" v-if="info.type == 0">{{ info.describe }}</div>
        <div class="list">
            <div class="item">
                <!-- type==0, 对应imagesArr ; type == 1 , 对应video/other_video ; type == 2 对应 thumb -->
                <div class="item_tu more" v-if="info.type == 0">
                    <div class="tu_wrap" v-for="(img,key) in info.imagesArr" :key="key" @click="zhanshitupian(info.imagesArr,key)">
                        <van-image fit="cover" :src="imageUrl+img" class="tu" :show-error="false" :show-loading="false" />
                    </div>
                </div>
                <!-- <div class="item_tu single" v-if="info.type == 2">
                    <van-image fit="cover" :src="info.thumb" class="tu" :show-error="false" :show-loading="false" />
                </div> -->
                <div class="page_video_play">
                    <div class="video" :style="info.type == 1 ? 'display:block;' : 'display:none;'">
                        <div class="youku_video" v-if="info.other_video" v-html="info.other_video"></div>
                        <div class="prism-player video_play" :id="playerId" :style="playStyle"></div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- 评论 收藏 点赞 -->
    <div class="actions">
        <div class="action comment">
            <div class="text" v-if="info.num">评论{{'('+ info.num.comment_num +')'}}</div>
        </div>
        <div :class="info.is_collect ? 'action collect collected' : 'action collect'" @click="clickCollect(info)">
            <div class="text" v-if="info.num">收藏{{'('+ info.num.collect_num +')'}}</div>
        </div>
        <div :class="info.is_like ? 'action like liked' : 'action like'" @click="clickLike(info)">
            <div class="text" v-if="info.num">点赞{{'('+ info.num.like_num +')'}}</div>
        </div>
    </div>
    <!-- 评论内容 -->
    <div class="page_iteminfo haserji">
        <div class="comment">
            <div class="con" v-for="(item,index) in commentArr" :key="index">
                <div class="con_top clearfix">
                    <div class="f-l thumb">
                        <img :src="item.userthumb ? ($publicData.withHttpStart(item.userthumb) ? item.userthumb : imageUrl+item.userthumb ) : $publicData.defaultTouxiang" alt="" class="thumb" />
                    </div>
                    <div class="f-l con_top_r">
                        <span class="user_name">{{ $publicData.formatPhone(item.username) }}</span>
                        <span class="time">{{ item.created_at }}</span>
                    </div>
                </div>
                <div class="con_nr">
					<!-- @click="toCommentSec(item)" -->
                    <div class="yiji_txt">{{ item.comment }}</div>
                    <!-- 二级回复 -->
                    <!-- <div class="huifu" v-if="item.second_num != 0">
                        <div class="item clearfix" v-for="huifu in (item.show_more_second ? item.second.slice(0,limited_num) : item.second)" :key="huifu.id">
                            <div class="user_name f-l" v-if="huifu.userdata">
                                {{ huifu.userdata.nickname ? huifu.userdata.nickname + ":" : huifu.userdata.username + ":" }}
                            </div>
                            <div class="erji_txt f-l slh_s">{{ huifu.comment }}</div>
                        </div>
                    	<div class="total item" v-if="item.show_more_second" @click="secondMore(item,index)">共有{{item.second_num}}条回复&nbsp;&gt;</div>
					</div> -->
                </div>
            </div>
        </div>
        <div class="morecomment" v-if="show_more" @click="loadMore">加载更多</div>
    </div>
    <!-- 评论 -->
    <div class="pinglun">
        <div class="filed">
            <van-field v-model="comment_text" :placeholder="placeholder" />
        </div>
        <div class="action" @click="toComment">评论</div>
    </div>
    <!-- 大图预览 -->
    <van-image-preview v-model="bigTuShow" :start-position="bigTuIndex" :images="bigTuImgArr" @change="bigTuChange"></van-image-preview>
</div>
</template>

<script>
import router from "../../../.././router";
import {
    LOGOUT,
    LOGIN
} from "../../../.././vuex/mutation_types";
import Vue from 'vue';
import Bridge from '../../../.././vuex/bridge.js'
Vue.prototype.$bridge = Bridge
var userAgent = navigator.userAgent

export default {
    data() {
        return {
			imageUrl: this.$publicData.uploadImage,
            publicPath: process.env.BASE_URL,
            token: null,
            comment_text: null, // 评论内容
            headline_id: this.$route.query.headline_id, // 头条id
            info: {},
            bigTuShow: false,
            bigTuIndex: 0,
            bigTuImgArr: null,
            page: 1,
            size: 10,
            commentArr: [],
            show_more: false,
            instance: null, // video 对象
            playerId: 'aliplayer_' +
                Math.random()
                .toString(36)
                .substr(2),
            playStyle: {
                height: '40vh',
                display: 'none'
            },
            player: null, // 初始化的播放器
            shareConfig: null,
            placeholder: '', // 评论占位符
			commentItem: null, // 二级评论
			limited_num: 1, // 二级评论隐藏条数限制
            isSendingMessage: false
        };
	},
	watch: {
		'commentArr': function(val,old){
			// 监测的是长度变化
			// console.log('触发了===',val)
		}
	},
    created: function () {

    },
    mounted() {
        console.log('-----------', this.playerId)
        var that = this
        if (userAgent && userAgent.indexOf('shidaijiyi') != -1) {
            var params = {
                'data': {
                    'naviTitle': '头条详情',
                    'rightStyle': 'share'
                }
            }
            this.$bridge.callhandler('sdjy://navigation/style', params, (data) => {

            })
            //获取用户信息
            var memberParams = {
                'data': {
                    'notCallLogin': 1,
                }
            }
            this.$bridge.callhandler('sdjy://member/memberInfo', memberParams, (data) => {
                if (data.code == 200) {
                    this.token = data.result.token
                } else {
                    this.token = ''
                }
                this.getData()
            })
            //注册方法，客户端重新进入页面刷新数据
            this.$bridge.registerhandler('sdjy://common/refreshPage', (data, responseCallback) => {
                // alert(JSON.stringify(data));
                responseCallback(data)
            })
            //注册方法，客户端重新进入页面刷新数据
            this.$bridge.registerhandler('sdjy://common/rightButtonAction', (data, responseCallback) => {
                // alert(JSON.stringify(data));
                console.log('sdjy://common/rightButtonAction')
                const url = location.href.split('#')[0];
                var params = {
                    data: {
                        title: that.info.type != 0 ? that.info.title : that.$publicData.shareDefaultTitleA,
                        detail: '',
                        url: url,
                        platFormType:'',
                        image: that.$publicData.domain + that.$publicData.shareDefaultIcon
                    },
                };
                this.$bridge.callhandler('sdjy://public/share', params, (data) => {

                })

            })
        } else {
            // 获取列表
            this.token = this.$store.getters.token
            this.getData()
        }

    },
    methods: {
        // 头条详情
        getData() {
            var params = {
                headline_id: this.headline_id,
                page: this.page,
                size: this.size
            }
            if (this.token && this.token != undefined && this.token != "") {
                params.token = this.token
            }
            this.$api.toutiao.headlineinfo(params).then(res => {
                if (res.code == 200) {
                    var info = res.result
                    // 分享
                    this.getShareData()
                    // 小图组成数组
                    if (info.images) {
                        info.imagesArr = info.images.split(',')
                    }
                    this.info = info
                    // 初始化播放器
                    if (info.type == 1) {
                        this.setPlayer()
                    }

                    // 评论 分页加载
                    var list = info.comment
                    if (list) {
                        if (list.length >= this.size) {
                            this.show_more = true
                        } else {
                            this.show_more = false
                        }
                        for (var i in list) {
                            var second = list[i].second
                            if (second && second.length != 0 && second.length > this.limited_num) {
                                list[i].second_num = second.length
                                list[i].show_more_second = true
                            } else {
                                list[i].second_num = 0
                                list[i].show_more_second = false
                            }
                            this.commentArr.push(list[i])
                        }
                    } else {
                        this.show_more = false
                    }
                    console.log('this.commentArr', this.commentArr)
                }
            })
        },
        // 展开大图
        zhanshitupian(arr, index) {
			for(let i in arr){
				arr[i] = this.imageUrl+arr[i];
			};
            this.bigTuImgArr = arr
            this.bigTuIndex = index
            this.bigTuShow = true
        },
        // 切换大图
        bigTuChange(index) {
            this.bigTuIndex = index
        },
        // 收藏
        clickCollect(item) {
            var is_collect = item.is_collect
            var params = {
                token: this.token,
                headline_id: item.id
            }
            this.$api.toutiao.collect(params).then(res => {
                if (res.code == 200) {
                    if (is_collect == 0) {
                        this.info.is_collect = 1
                        this.info.num.collect_num = parseInt(this.info.num.collect_num) + 1
                        this.$toast('收藏成功');
                    } else if (is_collect != 0) {
                        this.info.is_collect = 0
                        this.info.num.collect_num = parseInt(this.info.num.collect_num) - 1
                        this.$toast('取消收藏成功');
                    }
                }
            })
        },
        // 点赞
        clickLike(item) {
            var is_like = item.is_like
            var params = {
                token: this.token,
                headline_id: item.id
            }
            this.$api.toutiao.like(params).then(res => {
                if (res.code == 200) {
                    if (is_like == 0) {
                        this.info.is_like = 1
                        this.info.num.like_num = parseInt(this.info.num.like_num) + 1
                        this.$toast('点赞成功');
                    } else if (is_like != 0) {
                        this.info.is_like = 0
                        this.info.num.like_num = parseInt(this.info.num.like_num) - 1
                        this.$toast('取消点赞成功');
                    }
                }
            })
        },
        // 评论
        toComment() {
            if (!this.comment_text) {
                // this.$toast('请填写评论内容');
                return;
            }
            if (this.isSendingMessage == true) {
                return
            }
            var params = {
                token: this.token,
                content: this.comment_text,
                headline_id: this.info.id,
                // type: 1 // 1评论，2回复评论
            }
            if (this.commentItem) {
                params.type = 1
                params.fist_comment_id = this.commentItem.id
            }
            this.isSendingMessage = true
            this.$api.toutiao.comment(params).then(res => {
                if (res.code == 200) {
                    this.$toast('评论成功')
                    this.comment_text = ''
                    this.commentArr = []
                    this.page = 1
                    this.getData()
                    this.commentItem = null
                    this.placeholder = ''
                    this.isSendingMessage = false
                }
            })
        },
        // 加载更多评论
        loadMore() {
            this.page++
            this.getData()
        },
        // 播放器
        setPlayer() {
            var that = this
            if (this.info.other_video != '' && this.info.other_video != null) {
                return;
            }
            console.log('111')
            this.playStyle.display = 'block';
            this.instance = new Aliplayer({
                    id: this.playerId,
                    source: this.$publicData.domain + this.info.video,
                    width: '100%',
                    height: this.playStyle.height,
                    autoplay: true,
                    isLive: false,
                    rePlay: false,
                    playsinline: true,
                    preload: true,
                    controlBarVisibility: "hover",
                    useH5Prism: true,
                    skinLayout: [{
                            name: "bigPlayButton",
                            align: "blabs",
                            x: 30,
                            y: 80
                        },
                        {
                            name: "H5Loading",
                            align: "cc"
                        },
                        {
                            name: "infoDisplay"
                        },
                        {
                            name: "tooltip",
                            align: "blabs",
                            x: 0,
                            y: 56
                        },
                        {
                            name: "thumbnail"
                        },
                        {
                            name: "controlBar",
                            align: "blabs",
                            x: 0,
                            y: 0,
                            "children": [{
                                    "name": "progress",
                                    "align": "blabs",
                                    "x": 0,
                                    "y": 44
                                },
                                {
                                    "name": "playButton",
                                    "align": "tl",
                                    "x": 15,
                                    "y": 12
                                },
                                {
                                    "name": "timeDisplay",
                                    "align": "tl",
                                    "x": 10,
                                    "y": 7
                                },
                                {
                                    "name": "fullScreenButton",
                                    "align": "tr",
                                    "x": 10,
                                    "y": 12
                                },
                                {
                                    "name": "volume",
                                    "align": "tr",
                                    "x": 5,
                                    "y": 10
                                }
                            ]
                        }
                    ],
                    x5LandscapeAsFullScreen: false,
                    // x5_type:'h5',
                    showBarTime: 5000,
                    controlBarVisibility: "always",
                    x5_fullscreen: true,
                    x5_video_position: "top",
                    // "x5_orientation":"landscape",
                },
                function (player) {
                    that.player = player;
                    console.log('The player is created');
                    $("video").attr('x5-video-player-type', 'h5');
                    player.on("error", function (e) {
                        $(".prism-ErrorMessage").hide();
                        player.show_video = true;
                    });
                }
            );
        },
        // 获取分享参数 -- 用于配微信分享
        getShareData() {
            const url = location.href.split('#')[0];
            console.log('url', url)
            this.$api.index.commonShare({
                url: url
            }).then(res => {
                if (res.code == 200) {
                    this.shareConfig = res.result
                    // console.log('this.shareConfig', this.shareConfig)
                    // console.log('this.$route', this.$route)
                    this.shareFun()
                }
            })
        },
        // 分享
        shareFun() {
            var that = this
            wx.config({
                debug: that.shareConfig.debug,
                beta: that.shareConfig.beta,
                jsApiList: that.shareConfig.jsApiList,
                appId: that.shareConfig.appId,
                nonceStr: that.shareConfig.nonceStr, // 随机串
                timestamp: parseInt(that.shareConfig.timestamp), // 时间戳
                signature: that.shareConfig.signature // 签名
            });
            // 分享
            wx.ready(function () {
                const url = location.href.split('#')[0];
                var shareData = {
                    title: that.info.type != 0 ? that.info.title : that.$publicData.shareDefaultTitleA, // 分享标题
                    desc: '', // 分享描述,本身就没有描述
                    link: url, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
                    imgUrl: that.$publicData.domain + that.$publicData.shareDefaultIcon, // 分享图标
                    success: function () {
                        // 用户确认分享后执行的回调函数
                        // alert('成功')
                    },
                    cancel: function (e) {
                        // alert(e)
                        // 用户取消分享后执行的回调函数
                    }
                }
                wx.updateAppMessageShareData(shareData);
                wx.updateTimelineShareData(shareData);
            });
        },
        // 二级评论
        toCommentSec(item) {
            console.log('二级评论', item)
            var that = this
            that.commentItem = item
            that.placeholder = '回复' + item.username
        },
        // 二级评论加载
        secondMore(item,index) {
			// 方法一
			// var newArr = this.commentArr
			// this.commentArr = []  // 渲染监测的是长度变化,长度改变会重新渲染
            // for (var i in newArr) {
            //     var comment = newArr[i]
            //     if (comment.id == item.id) {
            //         // console.log('id', item.id)
            //         comment.show_more_second = !comment.show_more_second
            //     }
			// }
			// this.commentArr = newArr
			// console.log('评论', this.commentArr)
			// 方法二
			item.show_more_second = !item.show_more_second
			this.$set(this.commentArr,index,item)
			// console.log('set方法',this.commentArr)
        }
    }
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->

<style lang="postcss" scoped>
@import 'https://g.alicdn.com/de/prismplayer/2.7.2/skins/default/aliplayer-min.css';
</style>
